export default __webpack_public_path__ + "static/media/img-success.cf5ce6cc.svg";